<style>
    @import "./vip.less";
</style>
<template>
    <div class="lawtelephone">
        <div class="lawt_con">
            <div>
                <img src="./lawcomponent/images/lawjudgeback.png" alt='版权登记'/>
            </div>
        </div>
        <div class="lawt_fr_content">
            <div>
                <img src="./lawcomponent/images/lawtele3.png" alt='版权登记'/>
            </div>
            <div class="lawt_fr_content_rig">
                <p class="rg_title">电话问律师</p> 
                <p class="rg_tw_title">版权家专业律师，为您快速解答法律问题</p>
                <div style="margin-top:40px;">
                    <p class="rg_tw_title">请选择类型:</p>
                    <div style="margin-top:15px;">
                        <input @click="counselingTypesIndex=index" v-for="(item,index) in counselingTypes"
                               :class="counselingTypesIndex == index ? 'active' :'' " type="button"
                               :value="item.label" :key="index"/>
                    </div>
                </div>
                <div style="margin-top:27px">
                    <p class="rg_tw_title">请选择您要问律师的问题范围：</p>
                    <div style="margin-top:15px;">
                        <input @click="counselingScopeValue=item.value" v-for="(item,index) in counselingScope"
                               :class="counselingScopeValue == item.value ? 'active' :'' " type="button"
                               :value="item.name" :key="index"/>
                    </div>
                </div>
                <p v-if="lawyerConsultNum>0" class="vipstyle">您是{{ userInfo.accountType == 'person' ? '个人' : '企业'
                    }}VIP会员，当前剩余{{lawyerConsultNum}}次法律服务</p>
                <input @click="submitOrder" class="goOrderEsc" type="button" value="下单"/>
            </div>
        </div>
        <div class="lawt_parcontent">
            <div class="lawt_cont_title">
                <div>您可能还需要以下服务</div>
                <p></P>
            </div>
            <div style="padding-top:339px">
                <lawCommon activeId="1"/>
            </div>
        </div>
        <div class="lawtbo_content" style="padding-top:80px;padding-bottom:80px">
            <lawcommontw :content="content" :title="title"/>
            <img src="./lawcomponent/images/lawtele1.png" alt='版权登记'/>
        </div>
        <div class="lawtbo_se_content">
            <div class="lawtbo_se_clt">
                <img src="./lawcomponent/images/lawtele2.png" alt='版权登记'/>
                <div class="lawbojn">
                    <div class="lawbojncontent">
                        <div class="lawbojncontent_top">
                            <p>常见问答</p>
                            <div class="commonbottomDiv"></div>
                            <div v-for="(item,index) in records" :key="index"
                                 :class="records.length-1==index?'show_sea_con show_no_border':'show_sea_con'">
                                <div class="show_sea_con_t">
                                    <p class="show_answer">问</p>
                                    <p :title="item.content" class="show_answer_content">{{item.content}}</p>
                                </div>
                                <div class="show_sea_con_b">
                                    <p class="show_question">答</p>
                                    <div class="show_question_content">
                                        <div :title="item.reContent?item.reContent:''" class="show_question_content_t">
                                            {{item.reContent?item.reContent:''}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    电话问律师模态框    -->
        <generalframe class="telephone_model" @fatherMethod="fatherMethod" v-show="showDialog" myheight="628" mywidth="800" maintitle="电话问律师"
                      ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>接听手机：</p>
                    <Input v-model="phoneNum" maxlength="11" style="width: 188px;" type="text"
                           placeholder="请输入11位手机号码"/>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>预约时间：</p>
                    <div class="appointment_time">
                        <DatePicker v-model="appointmentDate" type="date" :options="timeLimit" placeholder="年-月-日"
                                    format="yyyy-MM-dd" @on-change="appointmentDateChange"></DatePicker>
                        <ul class="time_group" v-if="timeRange.length>0">
                            <li @click="timeClick(index)" v-for="(item,index) in timeRange" :key="index"
                                :class="timeRangeIndex == index ? 'active time_item' : 'time_item' ">
                                {{item.startDate}}-{{ item.endDate }}
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>咨询描述：</p>
                    <textarea maxlength="500" v-model="advisoryDesc" style="flex:1;min-height:120px;resize: none;padding: 5px;"
                              placeholder="请输入您需要判定的简要描述"></textarea>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p style="line-height: 42px;white-space: nowrap">支付方式：</p>
                    <div v-if="counselingTypes[counselingTypesIndex] && showDialog">
                        <pay-way
                            v-if="'0501' === counselingTypes[counselingTypesIndex].value"
                            @onselected="payWay30 = $event"
                            type="0501">
                        </pay-way>
                        <pay-way
                            v-if="'0502' === counselingTypes[counselingTypesIndex].value"
                            @onselected="payWay60 = $event"
                            type="0502">
                        </pay-way>
                        <!-- <pay-way v-if="monitorType === 'image'" @onselected="payWay60 = $event" type="0502"></pay-way> -->
                    </div>
                </div>
                <input @click="confirmSubmit" class="goOrderEsc confirm_submit" type="button" value="确认下单"/>

            </div>
        </generalframe>
        <!--    加油包    -->
        <monitorBag bizType="05" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
    </div>
</template>
<script>
    import lawcommontw from './lawcomponent/lawcomponenttw.vue'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import generalframe from './lawcomponent/generalframe.vue'
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import payWay from '@/views/main-components/pay-way';
    import util from '@/libs/util';
    import Cookies from "js-cookie";
    import {
        getAddLawyerAddSope,
        getAddLawyerAddChooseType,
        getAddLawyer,
        getTimeRange,
        getVipMemberright
    } from '@/api/staticPage';


    export default {
        metaInfo: {
            title: '电话问律师|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '电话问律师,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'lawTelephone',
        components: {
            lawcommontw,
            lawCommon,
            generalframe,
            monitorBag,
            myczPay,
            payWay
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                counselingTypes: [], //预约类型
                counselingTypesIndex: 0, //选中的预约类型
                counselingScope: [
                    {name: '发现被侵权', value: 'found_torted'},
                    {name: '侵权下架', value: 'tort_off_shelf'},
                    {name: '企业版权', value: 'enterprise_copyright'},
                    {name: '其他', value: 'other'},
                ], //预约范围
                counselingScopeValue: 'found_torted', //选中的范围
                lawyerConsultNum: 0, //法律服务剩余次数
                appointmentDate: '', //预约日期
                timeRange: [], //时间范围
                timeRangeIndex: null, //当前时间范围选中index
                timeRangeValue: '', //时间范围取值
                content: [
                    {content: '预约律师，确认下单', english: 'ONE'},
                    {content: '等待律师，电话联系', english: 'TWO'},
                    {content: '双方沟通，解答问题', english: 'THREE'},
                    {content: '服务完成，平台回访', english: 'FOUR'},
                ], //律师服务流程
                title: '律师服务流程',
                records: [
                    {
                        content: '一次付费咨询可以通话多久？',
                        reContent: '通话时长应控制在30分钟以内，如超出时间，律师可选择结束咨询。'
                    },
                    {
                        content: '下单后谁会联系我？',
                        reContent: '下单后，律师会给您回电话，我们要求律师在20分钟内响应。'
                    },
                    {
                        content: '律师超时未联系怎么办？',
                        reContent: '有时律师可能因为开庭等事项无法及时响应，如果超时未响应，请联系平台客服，版权家客服经理会为您协调更换律师。'
                    },
                    {
                        content: '咨询律师前需要准备什么？',
                        reContent: '为了高效利用您的咨询时间，请在下单前尽可能把您需要准备的问题梳理清楚。'
                    },
                    {
                        content: '和律师沟通后，有意向委托律师服务，该怎么办？',
                        reContent: '如果是合同、侵权下架等平台已有的服务，您可以直接在平台下单即可，如果平台上没有的产品您可以联系平台客服，平台客服经理会为您安排。'
                    },
                ], //问答
                showDialog: !1,
                phoneNum: '', //手机号
                advisoryDesc: '', //咨询描述
                timeLimit: {
                    disabledDate(date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }, //时间限制
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false, //会员监测模态框展示状态
                payWay30: null,
                payWay60: null,

            }
        },
        watch:{
	    	"$store.state.app.showPayWay":function(){
	    		if(Cookies.get("userInfo")){
	    			this.userInfo = JSON.parse(Cookies.get("userInfo"))
	    		}
	    	}
	    },
        methods: {
            /************选择类型***********/
            counselingTypesClick() {

            },

            /************选择类型接口数据***********/
            _getAddLawyerAddChooseType() {
                getAddLawyerAddChooseType().then(res => {
                    if (res.code == 200) {
                        let result = res.result;
                        console.log(result)
                        this.counselingTypes = result;
                        this.counselingTypesValue = result[0].value;
                    } else {
                        toast(res.message);
                    }
                })
            },

            /************选择范围接口数据***********/
            _getAddLawyerAddSope() {
                let _this = this;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                let params = {
                    // id: userInfo && userInfo.id ? userInfo.id : '',
                    askScope: 'found_torted'
                };
                getAddLawyerAddSope(params).then(res => {
                    console.log('获取到的选择范围', res)
                })
            },

            /************选择时间接口数据***********/
            _getTimeRange() {
                let params = {
                    time: this.counselingTypes[this.counselingTypesIndex].remarks,
                    date: this.appointmentDate,
                };
                getTimeRange(params).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.timeRange = res.result;
                    } else {
                        toast(res.message)
                    }
                })
            },

            /************提交接口***********/
            _getAddLawyer() {
                let params = {
                    registerId:this.userInfo && this.userInfo.id?this.userInfo.id:'',
                    callbackMobilePhone: this.phoneNum,
                    appointment: (this.timeRangeValue!='' ? this.appointmentDate + ' ' + this.timeRangeValue : this.appointmentDate),
                    questionDesc: this.advisoryDesc,
                    subBizType: this.counselingTypes[this.counselingTypesIndex].value,
                    askScope: this.counselingScopeValue
                };
                if (this.counselingTypes[this.counselingTypesIndex].value === '0501') {
                    console.log(this.payWay30);
                    if (this.payWay30 && this.payWay30.gift && this.payWay30.gift.countNumber) {
                        Object.assign(params, {activityGiftId: this.payWay30.gift.activityGiftId && this.payWay30.gift.activityGiftId!='' ? this.payWay30.gift.activityGiftId : '' })
                    } else {
                        toast('可用次数不足')
                        return
                    }
                }
                if (this.counselingTypes[this.counselingTypesIndex].value === '0502') {
                    console.log(this.payWay60);
                    if (this.payWay60 && this.payWay60.gift && this.payWay60.gift.countNumber) {
                        Object.assign(params, {activityGiftId: this.payWay60.gift.activityGiftId && this.payWay60.gift.activityGiftId!='' ? this.payWay60.gift.activityGiftId : '' })
                    } else {
                        toast('可用次数不足')
                        return;
                    }
                }
                getAddLawyer(params).then(res => {
                    console.log(res);

                    let message = res.message;
                    let _this = this;

                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            this.lawyerConsultNum = this.lawyerConsultNum - 1;
                            this.fatherMethod();
                            toast('提交成功！请前往【个人中心】查看订单服务详情');
                            break;
                        }

                        //VIP已到期--弹框
                        case 215: {
                            toast(message, () => {
                                this.myczPayState = true;
                            });
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }


                }, (err) => {
                    toast('提交失败，请重试');
                })
            },

            /************服务次数接口***********/
            _getVipMemberright() {
                let _this = this;
                let userInfo = this.userInfo;

                if (userInfo && userInfo != '' && userInfo.vipFlag!=0) {
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    };
                    getVipMemberright(params).then(res => {
                        if (res.code == 200) {
                            this.lawyerConsultNum = res.result.lawyerConsultNum;
                        }
                    })
                }

            },

            /***************页面外部的下单点击事件**************/
            submitOrder() {
            	if (this.userInfo == '') {
                	this.$store.state.app.showLoginOrRegistter = true
                    return false;
                } else if (this.counselingTypesValue == '' || this.counselingScopeValue == '') {
                    toast('请选择完整后提交')
                }
                this.showDialog = 1;
            },

            /****************第二步-确认下单**************/
            confirmSubmit() {
                let phoneNum = this.phoneNum;
                let advisoryDesc= this.advisoryDesc.replace(/^\s+|\s+$/g,'');
                if (!util.checkPhoneNum(phoneNum)) {
                    toast('请填写正确的手机号再提交');
                } else if (advisoryDesc == '' || this.appointmentDate == '' || (this.timeRange.length>0 ? this.timeRangeValue =='' : '' )) {
                    toast('请填写完整后再提交');
                } else {
                    this._getAddLawyer()
                }


            },

            /***************接收提交弹框的关闭事件**************/
            fatherMethod() {
                let _this = this;
                _this.showDialog = !1;
                this.phoneNum = '';
                this.advisoryDesc = '';
                this.appointmentDate = '';
                this.timeRange = [];
            },

            /***************日期改变事件**************/
            appointmentDateChange(val) {
                this.appointmentDate = val;
                this.timeRange = [];
                this.timeRangeIndex = null;
                this.timeRangeValue = '';
                if(val && val!=''){
                    this._getTimeRange();
                }

            },


            timeClick(index) {
                this.timeRangeIndex = index;
                let nowTimeRange = this.timeRange[index];
                this.timeRangeValue = nowTimeRange.startDate + '-' + nowTimeRange.endDate;
            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },

            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },


        },
        mounted() {
            this._getAddLawyerAddChooseType();

            // this._getAddLawyerAddSope();
            this._getVipMemberright();
        }
    }
</script>
<style scoped lang="less">
    .lawtelephone {
        // margin-bottom: 200px;
        .lawt_con {
            height: 422px;

            img {
                max-width: 100%;
                display: block;
                height: 100%;
            }
        }

        .lawt_fr_content {
            width: 1334px;
            // height: 554px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 4px;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: -400px;
            z-index: 555;
            position: absolute;
            display: flex;
            justify-content: flex-start;

            img {
                width: 506px;
                height: 510px;
                display: block;
                margin: 22px 0 22px 22px;
            }

            .lawt_fr_content_rig {
                margin-left: 37px;

                .rg_title {
                    height: 28px;
                    font-size: 20px;
                    font-weight: bold;
                    color: rgba(65, 65, 65, 1);
                    line-height: 28px;
                    margin-top: 40px;
                }

                .rg_tw_title {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(65, 65, 65, 1);
                    line-height: 20px;
                }

                input {
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px;
                    border: 1px solid rgba(199, 199, 199, 1);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    margin-right: 20px;
                    margin-bottom: 20px;

                    &:hover {
                        background: rgba(255, 216, 0, 1);
                        border: none;
                        padding: 1px;
                    }

                    &.goOrderEsc:hover {
                        padding: 0;
                    }
                }

                .active {
                    background: rgba(255, 216, 0, 1);
                    border: none;
                    padding: 1px;
                }

                .vipstyle {
                    height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(37, 37, 37, 1);
                    line-height: 20px;
                    margin-top: 21px;
                }

                .goOrderEsc {
                    margin-top: 20px;
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 2px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .lawt_parcontent {
            height: 696px;
            background: rgba(250, 252, 254, 1);

            .lawt_cont_title {
                width: 1334px;
                margin: 0 auto;
                position: relative;
                top: 185px;

                div {
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 3;
                    top: 56px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: 400;
                    color: rgba(4, 4, 4, 1);
                    letter-spacing: 3px;
                }

                p {
                    width: 55px;
                    height: 55px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 2;
                    top: 50px;
                }
            }
        }

        .lawtbo_content {
            width: 1334px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 667px;
                height: 456px;
            }
        }

        .lawtbo_se_content {
            height: 829px;
            background: rgba(250, 252, 254, 1);

            .lawtbo_se_clt {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                img {
                    width: 434px;
                    height: 629px;
                }

                .lawbojn {
                    width: 900px;
                    height: 629px;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                    border-radius: 2px;

                    .lawbojncontent {
                        margin-left: 36px;
                        margin-top: 10px;

                        .lawbojncontent_top {
                            p {
                                height: 36px;
                                font-size: 25px;
                                font-weight: 400;
                                color: rgba(4, 4, 4, 1);
                                line-height: 36px;
                                letter-spacing: 3px;
                            }

                            .commonbottomDiv {
                                width: 193px;
                                height: 25px;
                                background: rgba(216, 216, 216, 1);
                                opacity: 0.15;
                                margin-top: -20px;
                                margin-bottom: 38px;
                            }

                            .show_no_border {
                                border: none !important;
                            }

                            .show_sea_con {
                                border-bottom: 1px solid rgba(238, 238, 238, 1);

                                .show_sea_con_t {
                                    display: flex;
                                    justify-content: flex-start;
                                    padding-top: 20px;
                                    align-items: center;

                                    .show_answer {
                                        width: 23px;
                                        height: 16px;
                                        background: rgba(255, 98, 70, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        -webkit-transform: scale(0.91);
                                        text-align: center;
                                        line-height: 16px;
                                    }

                                    .show_answer_content {
                                        height: 22px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        color: rgba(51, 51, 51, 1);
                                        line-height: 22px;
                                        margin-left: 15px;
                                        max-width: 800px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }

                                .show_sea_con_b {
                                    display: flex;
                                    justify-content: flex-start;
                                    margin-top: 11px;

                                    .show_question {
                                        width: 27px;
                                        height: 16px;
                                        background: rgba(72, 131, 247, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        -webkit-transform: scale(0.91);
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        text-align: center;
                                        line-height: 16px;
                                        margin-top: 3px;
                                    }

                                    .show_question_content {
                                        margin-left: 11px;
                                        max-width: 800px;

                                        .show_question_content_t {
                                            font-size: 14px;
                                            font-weight: 400;
                                            color: rgba(102, 102, 102, 1);
                                            line-height: 22px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                            overflow: hidden;
                                            margin-bottom: 17px;
                                        }

                                        .show_question_content_d {
                                            display: flex;
                                            justify-content: space-between;
                                            align-items: center;
                                            margin-top: 5px;

                                            p {
                                                height: 22px;
                                                font-size: 12px;
                                                font-weight: 400;
                                                color: rgba(153, 153, 153, 1);
                                                line-height: 22px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .ts_content {
            padding: 30px;

            .ts_content_fr {
                display: flex;
                justify-content: flex-start;

                p {
                    width: 70px;
                    text-align: left;
                    margin-right: 10px;
                }

                .appointment_time {
                    flex: 1;
                    text-align: left;

                    .time_group {
                        padding-top: 20px;
                        display: flex;
                        flex-wrap: wrap;

                        .time_item {
                            box-sizing: border-box;
                            padding: 0 5px;
                            text-align: center;
                            width: 170px;
                            height: 42px;
                            line-height: 42px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            border-radius: 2px;
                            border: 1px solid #c7c7c7;
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            cursor: pointer;
                            margin-bottom: 10px;
                            margin-right: 20px;

                            &:hover, &.active {
                                border: none;
                                padding: 1px 6px;
                                background: rgba(255, 216, 0, 1);
                            }

                            &.disable {
                                background: #f3f3f3;
                                cursor: not-allowed;
                                border: 1px solid #dcdee2;
                                padding: 0 5px;
                            }
                        }

                        .time_item:nth-child(3n) {
                            margin-right: 0;
                        }
                    }
                }

            }

            .confirm_submit {
                margin-top: 0;
            }
        }

        .goOrderEsc {
            margin-top: 20px;
            width: 137px;
            height: 42px;
            background: rgba(255, 216, 0, 1);
            border-radius: 2px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
            outline: none;
            border: none;
            cursor: pointer;
        }
    }

    .telephone_model{
        /deep/.generalcontent{
            overflow-y: auto;

        }
    }
</style>